import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { addToCart, addToGuestCart } from "../store"
import { useToast } from "../hooks/useToast"
import "./styles/AddToCartButton.css"

const AddToCartButton = (props) => {
  const auth = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const { notify } = useToast()

  const handleAddToCart = () => {
    if (auth.id) {
      dispatch(addToCart(props))
    } else {
      dispatch(addToGuestCart(props))
    }
    notify("Added to Cart", "Success")
  }
  return (
    <div className="flex w-full flex-row-reverse p-2">
      <button onClick={handleAddToCart} className="AddToCartButton">
        <span className="AddToCartButtonText">Add to Cart</span>
        <span className="AddToCartButtonIconContainer">
          <svg
            className="AddToCartButtonIconSVG"
            fill="none"
            height="24"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line x1="12" x2="12" y1="5" y2="19"></line>
            <line x1="5" x2="19" y1="12" y2="12"></line>
          </svg>
        </span>
      </button>
    </div>
  )
}

export default AddToCartButton
